import { dashboardTour } from './dashboard-tour';
import { sidebarTour } from './sidebar-tour';
import { leadsTour } from './leads-tour';
import { clientsTour } from './clients-tour';
import { clientDetailsTour } from './client-details-tour';
import { foodsTour } from './foods-tour';
import { dietTemplatesTour } from './diet-templates-tour';
import { dietPlansTour } from './diet-plans-tour';
import { settingsTour } from './settings-tour';
import { contentTour } from './content-tour';
import { counsellingTour } from './counselling-tour';
import { leadFormsTour } from './lead-forms-tour';
import { auditLogsTour } from './audit-logs-tour';
import { organizationSettingsTour } from './organization-settings-tour';
import { integrationsTour } from './integrations-tour';
import { billingTour } from './billing-tour';
import type { TourConfig } from './types';

export const tours: Record<string, TourConfig> = {
  [dashboardTour.id]: dashboardTour,
  [sidebarTour.id]: sidebarTour,
  [leadsTour.id]: leadsTour,
  [clientsTour.id]: clientsTour,
  [clientDetailsTour.id]: clientDetailsTour,
  [foodsTour.id]: foodsTour,
  [dietTemplatesTour.id]: dietTemplatesTour,
  [dietPlansTour.id]: dietPlansTour,
  [settingsTour.id]: settingsTour,
  [contentTour.id]: contentTour,
  [counsellingTour.id]: counsellingTour,
  [leadFormsTour.id]: leadFormsTour,
  [auditLogsTour.id]: auditLogsTour,
  [organizationSettingsTour.id]: organizationSettingsTour,
  [integrationsTour.id]: integrationsTour,
  [billingTour.id]: billingTour,
};

export * from './types';
export {
  dashboardTour,
  sidebarTour,
  leadsTour,
  clientsTour,
  clientDetailsTour,
  foodsTour,
  dietTemplatesTour,
  dietPlansTour,
  settingsTour,
  contentTour,
  counsellingTour,
  leadFormsTour,
  auditLogsTour,
  organizationSettingsTour,
  integrationsTour,
  billingTour,
};
